<template>
	<v-dialog v-model="showDialog" width="32%" persistent>
		<v-card flat style="height: 80vh" class="d-flex flex-column card-header-details">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col cols="10">
						<v-toolbar-title>{{ $t('prescriptions') }}</v-toolbar-title>
					</v-col>
					<v-spacer />
					<v-icon @click="$emit('exitViewAllMedicationsDialog')" class="white-icon">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text style="overflow-y: auto" class="px-2 pb-2">
				<v-card v-for="prescription in prescriptions" :key="prescription.id" class="mx-2 my-4 pa-4">
					<v-row>
						<v-col cols="6" class="text-left">
							<v-icon size="1.9vh">mdi-prescription</v-icon>
						</v-col>
						<v-col cols="6" class="text-right">
							<v-icon size="1.9vh" color="primary">mdi-delete</v-icon>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row dense>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('prescribed-by') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2">{{ prescription.medicalStaffFullName }}</span>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('prescribed-on') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2">{{
								formatDate(prescription.prescribedAt)
							}}</span>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('brand-name') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2">{{ prescription.brandName }}</span>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('generic-name') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2">{{ prescription.genericName }}</span>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('manufacturer-name') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2">{{ prescription.manufacturerName }}</span>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('dosage') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2">{{ prescription.dosage }}</span>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('frequency') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2">{{ prescription.frequency }}</span>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('period') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2"
								>{{ prescription.durationDays }} {{ $t('days') }}</span
							>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row>
						<v-col cols="4" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('route') }}:</span>
						</v-col>
						<v-col cols="8" class="text-right">
							<span class="font-weight-medium grey--text text--darken-2">{{ prescription.route }}</span>
						</v-col>
					</v-row>
					<v-divider style="margin-top: 10px; margin-bottom: 10px" />
					<v-row dense>
						<v-col cols="12" class="text-left">
							<span class="font-weight-medium grey--text text--darken-2">{{ $t('additional-information') }}:</span>
						</v-col>
						<v-col cols="12" class="text-left">
							<v-textarea
								rows="4"
								class="font-weight-medium black--text"
								no-resize
								outlined
								disabled
								hide-details
								background-color="grey lighten-5"
								:value="prescription.additionalinfo ?? $t('no-info')" />
						</v-col>
					</v-row>
				</v-card>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { formatterFilter } from '@/utils/luxon-formater';
import { mapState } from 'vuex';

export default {
	props: ['showDialog'],
	computed: {
		...mapState({
			prescriptions: (state) => state.prescriptions.prescriptions,
		}),
	},
	methods: {
		formatDate (val) {
			const dateObject = new Date(val);
			return formatterFilter(dateObject, 'date_med', this.timeLocalization, null);
		},
	},
};
</script>
